import * as React from 'react'
import { Five, parseWork } from '@realsee/five'
import './Space.css'
import PropTypes from "prop-types";
import classNames from "classnames";
import ModelViewPlugin from '@realsee/dnalogel/libs/ModelViewPlugin'

const FiveContext = React.createContext(null)

function withFive(CustomerComponent) {
	return function WrappedComponent (props) {
		const { ...resProps } = props
		return <FiveContext.Consumer>
			{ five => five ? <CustomerComponent five={five} {...resProps}/> : <div className="null"></div> }
		</FiveContext.Consumer>
	}
}

class Space extends React.Component {
	constructor (props) {
		
		super(props);
		
		this.state = {
			five: null,
			work: props.work
		};
	}
	
	componentDidMount (): void {
		this.initFive(this.state.work)
	}
	
	
	componentDidUpdate (prevProps, prevState, snapshot) {
		if (prevState.work !== this.state.work) {
			this.initFive(this.state.work)
		}
		if (prevProps.state !== this.props.state && this.state.five) {
			this.state.five.setState(this.props.state, false, false)
		}
		if (prevProps.isSplit !== this.props.isSplit && this.state.five) {
			this.state.five.refresh()
		}
	}
	
	initFive = (data) => {
		if (this.state.five) return
		const initOptions = {
			imageOptions: { size: 1024 },
			textureOptions: { size: 512 },
			maxFps: 70,
			play: true,
			poweredByRealsee: true,
			onlyRenderIfNeeds: true,
			floorplan: {
				defaultFov: 80,
				minFov: 60,
				maxFov: 120,
				defaultLatitude: 0,
				defaultLongitude: 0,
				minLatitude: 0,
				maxLatitude: Math.PI / 2
			},
			plugins: [[ModelViewPlugin, 'minimodel']]
		}
		const five = new Five(initOptions)
		const fiveWrapDom = document.querySelector(`#${this.props.spaceRootId}`)
		five.appendTo(fiveWrapDom)
		five.load(parseWork(data))
		
		five.once('modelLoaded', () => {
			this.setState({five: five})
		})
		five.on('stateChange', (state, userAction) => {
			if(!userAction) return
			this.props.onStateChange(JSON.parse(JSON.stringify(state)))
		})
		
		window.addEventListener('resize', () => five.refresh(), false)
	}
	
	componentWillUnmount () {
		this.state.five.dispose()
	}
	
	render () {
		const { children, spaceRootId, isMain, isSplit } = this.props
		const containerCls = classNames("vr-container", {'main': isMain}, {'split': isSplit})
		
		return (
			<div id={spaceRootId} className={containerCls}>
				<FiveContext.Provider value={this.state.five}>
					{children}
				</FiveContext.Provider>
			</div>
		);
	}
}
Space.propTypes = {
	children: PropTypes.any,
	spaceRootId: PropTypes.string.isRequired,
	work: PropTypes.any.isRequired,
	isMain: PropTypes.bool.isRequired,
	isSplit: PropTypes.bool.isRequired,
	state: PropTypes.any,
	onStateChange: PropTypes.func
};

Space.defaultProps = {
	spaceRootId: '',
	work: null
}

Space.withSpace = withFive

export default Space;
